import { Autocomplete, CircularProgress, IconButton, TextField } from "@mui/material";
import theme from "../../../../theme/Theme";
import * as React from "react";
import ChevronDown from "../../../../../public/assets/icons/chevron-down.svg";

/*
* onValueChange: when an autocomplete dropdown value is selected
* setText: when the text in the autocomplete input changes
* selectedValue: the currently selected value in the autocomplete dropdown
*   - if the operator is "in" this will be an array of values
*   - if the operator is not "in" this will be a single value still in an array
*   - Object: {label: string, id: string}
* */

export default function AutocompleteInput(props) {
  const { values, setValues, filterOptions, columnOptions, optionsDict } = props;
  const { onValueChange, searchDebounce } = props;
  const { selectedValue, selectedField, selectedOperator, selectedFieldId, setSelectedFieldId } = props;
  const { loading, nonManagerDetail } = props;
  const { text, setText } = props;
  const { styles, disabled } = props;
  const [open, setOpen] = React.useState(false);


  React.useEffect(() => {
    selectedOperator !== "in" && setText(selectedValue?.map(val => val?.label)?.join(",") || "");
  }, [selectedValue]);

  return (
    <Autocomplete
      data-testid="autocomplete-input-component"
      multiple={selectedOperator === "in"}
      freeSolo
     open={open}
      options={values}
      getOptionLabel={option => option?.label?.toString() ?? ""}
      loading={loading}
      filterOptions={filterOptions}
      value={selectedValue ?? [{ label: "", id: "" }]}
      inputValue={
        text === undefined ? "" :
          selectedOperator === "in"
            ? text.length ? text : ""
            : text.length ? text : (selectedValue ?? [{ label: "", id: "" }])?.map(val => val?.label)?.join(",")
      }
      onInputChange={(e, newValue) => {
        if (e !== null)
          setText(newValue);
      }}
      sx={{
        width: 300,
        ...styles
      }}
      size="small"
      onChange={(event, newValue) => {
  onValueChange(event, newValue);
  setOpen(false);
}}

      disabled={nonManagerDetail || disabled}
      componentsProps={{
        popper: {
          sx: {
            "& .MuiAutocomplete-listbox": {
              width: "100%"
            }
          },
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          data-testid="autocomplete-input-field"
          onClick={() => setOpen(prev => !prev)}
          onChange={(e) => {
            let parsedSelectedFieldId = selectedFieldId

            /* Searching depends on a previously selected field, if you are
             editing a filter and try to change a value without changing the field nothing will happen
             This is a workaround to allow searching without changing the field: */
            const found = columnOptions?.find(col => col?.field === selectedField)?.id;
            if ((found !== undefined) && (found !== selectedFieldId)) {
              parsedSelectedFieldId = columnOptions?.find(col => col?.field === selectedField)?.id;
              setSelectedFieldId(parsedSelectedFieldId);
            }

              searchDebounce(e.target.value);
          }}
          placeholder={selectedOperator === "in" ? "" : "Start typing a value"}
          sx={{
            "& .MuiAutocomplete-inputRoot": {
              borderRadius: 0,
              paddingRight: "8px !important",
            },
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                border: `1px solid ${theme.palette.artisticStroke200.main}`,
              },
            },
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20}/>
                ) : null}
                <IconButton disableRipple
                onClick={(e) => {
                  e.stopPropagation();
                    setOpen(prev => !prev);
                  }}
                  sx={{
                transition: "transform 0.3s ease",
                transform: open ? "rotate(180deg)" : "rotate(0deg)",
              }}
                >
                  <img src={ChevronDown} alt="chevron-down"/>
                </IconButton>
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
